import { Action } from 'redux';

import { IBuild } from '@models';

export const GOT_BUILDS = 'GOT_BUILDS';

export interface IBuildsAction extends Action {
  payload: IBuild[];
}

export type BuildsActionsType = IBuildsAction;

export interface IBuildsState {
  builds: IBuild[];
}
